var cart = require("../cart/cartGlobal");
var customBoxes = require("../components/cartCustomBoxes");
const isLoyaltyEnabled = $("meta[name=isLoyaltyEnabled]").attr("content") === "true";
let updateMiniCart = true;

module.exports = function () {
    cart();

    const $html = $("html");
    const $body = $("body");
    const $header = $(".page-header");
    const $minicart = $(".minicart");
    const $minicartPopover = $header.find(".minicart-popover");
    const $minicartQtyResource = $minicart.attr("data-resource");
    const $pdpQuantitySelector = $(".quantity-select.pdp-select");

    $minicart.on("count:update", function (event, count) {
        var $minicartQty = count.quantityTotal < 100 ? count.quantityTotal : $minicartQtyResource;
        if (count && $.isNumeric(count.quantityTotal)) {
            const $this = $(this);

            $this.find(".minicart-quantity").text($minicartQty);
            $this.find(".minicart-link").attr({
                "data-minicart-items": count.quantityTotal
            });
        }
    });

    $minicart.on("click", ".minicart-total", function (e) {
        const itemsCount = parseInt($minicart.find(".minicart-link").attr("data-minicart-items"), 10);
        const simulatedClick = !e.originalEvent;

        if (isLoyaltyEnabled) {
            $("body").trigger("updateMiniCartQty");
        }

        if (simulatedClick && itemsCount && $(window).width() > 768 && !$(".cart-page").length) {
            e.preventDefault();

            if ($(".search:visible").length === 0) {
                return;
            }

            if ($header.find(".minicart-popover.show").length === 0) {
                $html.addClass("js-no-scroll");

                if (!updateMiniCart) {
                    $minicartPopover.addClass("show");
                    return;
                }

                $minicartPopover.addClass("show");
                $minicartPopover.spinner().start();
                $body.trigger("minicart:refresh");

            }
        }
    });

    $body.on("click", function (e) {
        if ($minicartPopover.hasClass("show") &&
            $minicartPopover.has(e.target).length <= 0 && $minicart.has(e.target).length <= 0 && !$(e.target).closest("#removeProductModal").length) {
            $minicartPopover.removeClass("show");
            $html.removeClass("js-no-scroll");

            if ($pdpQuantitySelector.length) {
                $pdpQuantitySelector.trigger("select2:refresh");
            }
        }
    });

    $body.on("change", ".minicart .quantity", function () {
        if ($(this).parents(".bonus-product-line-item").length && $(".cart-page").length) {
            location.reload();
        }
    });

    $body.on("click", ".minicart-close-button", () => {
        $header.find(".popover").removeClass("show");
        $html.removeClass("js-no-scroll");

        if ($pdpQuantitySelector.length) {
            $pdpQuantitySelector.trigger("select2:refresh");
        }
    });

    $body.on("product:afterAddToCart", function () {
        updateMiniCart = true;
    });

    $body.on("cart:update", function () {
        updateMiniCart = true;
    });
    $body.on("click", ".cart-delete-confirmation-btn", () => {
        if ($minicartPopover.find(".product-summary .card").length > 3) {
            $minicartPopover.removeClass("mini-cart-scroll");
        }

        if ($pdpQuantitySelector.length) {
            $pdpQuantitySelector.trigger("select2:set.refresh").trigger("select2:refresh");
        }
    });

    $body.on("change", ".minicart-popover .quantity", function (e) {
        e.preventDefault();

        var valueSelected = $(this).val() ? parseInt($(this).val(), 10) : 0;
        var maxOrder = $(".product-detail").data("max-order");
        var maxOrderQuantity = parseInt(maxOrder, 10) ? parseInt(maxOrder, 10) : 0;

        if ($pdpQuantitySelector.length) {
            $pdpQuantitySelector.trigger("select2:set.refresh");
        }

        if (valueSelected < maxOrderQuantity) {
            location.reload();
        }
    });

    $body.on("click", ".cart-delete-confirmation-btn", function () {
        var url = $minicart.data("action-url");
        $.spinner().start();

        $.get(url, function (data) {

            $minicartPopover.empty();
            $minicartPopover.append(data);

            $minicartPopover.find("select.quantity").each(function () {
                var $this = $(this);

                $this.select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $this.closest(".product-summary")
                });
                $minicartPopover.find(".card").each(function () {
                    if (!$(this).hasClass("product-outstock")) {
                        $(".btn-total").removeAttr("disabled");
                    }
                });
            });

            updateMiniCart = false;
            $.spinner().stop();
        });

        if ($(".product-infos").find(".cart-and-ipay").length > 0 && $(".product-infos").find(".cart-and-ipay").data("is-instock") === true || $("#quantity-1").val() === "0") {
            location.reload();
        }

    });

    $body.on("minicart:refresh", function() {
        const url = $minicart.data("action-url");

        $.get(url, function (data) {
            $minicartPopover.empty();
            $minicartPopover.append(data);
            $minicartPopover.find("select.quantity").each(function () {
                const $this = $(this);

                $this.select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $this.closest(".product-summary")
                });
                $minicartPopover.find(".card").each(function () {
                    if (!$(this).hasClass("product-outstock")) {
                        $(".btn-total").removeAttr("disabled");
                    }
                });
            });
            $minicartPopover.find(".product-summary .card").length > 3 ? $minicartPopover.addClass("mini-cart-scroll") : $minicartPopover.removeClass("mini-cart-scroll");
            updateMiniCart = false;
            customBoxes.init();
            $.spinner().stop();
        });
    });
};
